<template>
  <div class="page" id="page-my-insurance">

    <!--
    <div class="layer"></div>
  -->

    <div class="section" id="section-my-insurance-landing">
      <div class="container">
        <h1>MY보험</h1>
        <p class="logout" v-if="this.$store.state.customer.profile._id" @click="logout">로그아웃</router-link></p>
        <!--<p class="login" v-if="!this.$store.state.customer.profile._id"><router-link :to="{ name: 'Auth' }">로그인</router-link></p>-->
        <p v-if="!this.$store.state.customer.profile._id"><router-link class="login" :to="{ name: 'Auth' }">로그인</router-link>이 필요한 서비스입니다.</p>
        <p v-if="this.$store.state.customer.profile._id">안녕하세요. {{this.$store.state.customer.profile.customer_name}}님</p>
      </div>
    </div>

    <div class="section" id="section-my-insurance-introduction">
      <div class="container">
        <div class="section-header">
          <div class="container">
            <element-tab>
              <element-tab-item @click="introductionTab = '고객정보관리'" :on="introductionTab == '고객정보관리'">고객정보관리</element-tab-item>
            </element-tab>
          </div>
        </div>
        <div class="section-body">
          <div class="container">

            <div id="introduction-tab-service" v-if="introductionTab == '고객정보관리'">
              <div class="subsection">
                <div id="myinsurance-tab-service">
                  <div>1</div>
                  <div>2</div>
                  <div>3</div>
                  <div>4</div>
                  <div>5</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section-footer">
        <div class="container">
          <div class="footer-link">
            <router-link :to="{ name: 'FAQ' }">나의 질문과 답변</router-link>
          <img :src="'../static/chevron_right.png'" />
          </div>
          <div class="footer-link">
            <ul>
              <li @click="clickTerms(index)" > <p @click="statusPopup = true">개인정보 관리</p></li>
              <element-term-popup v-model="statusPopup"/>
            </ul>
          </div>
        </div>
        <div class="container" style="max-width: 760px;">
          <p style="font-size: 11px;" >※ 이 견적서의 보험료는 보험가입일, 보험개발원 적용율, 보험사별 차량가액 및 인수 기준에 따라 변경될 수 있습니다.</p>
        </div>
      </div>

    </div>


  </div>
</template>
<script>
export default {
  data () {
    return {
      statusPopup : false,
      introductionTab: '고객정보관리'
    }
  },
  methods: {
    logout() {
      this.$store.dispatch( "customer/getAuth", {} ).then(res => {
        location.href="/"
      });
    },
    clickTerms( index ) {
      this.value[index].value = !this.value[index].value;
    },
  }
}
</script>